import React, { useState, useEffect } from 'react';
import { Modal, Col, ModalHeader } from 'reactstrap';
import axios from 'axios';
import { environment } from '../../../environment/environment';
import './AdvanceHistoryModal.css';
import AdvanceHistoryModalTable from './AdvanceHistoryModalTable';
import AdvanceStatusInfoTable from './AdvanceStatusInfoTable';
import EmployeeModalTable from './EmployeeModalTable';
import apiResponseHandler from '../../../utils/apiResponseHandler';
import {
  IAdvanceHistoryReturnType,
  IAdvanceRequestType,
} from '../../../types/AdvanceRequestTypes';
import AdvanceProviderInformationTable from './AdvanceProviderInformationTable';
import PaysoftActionsSection from './PaysoftActionsSection';

interface AdvanceHistoryModalProps {
  advanceRequest: IAdvanceRequestType;
  showAdvanceHistoryModal: boolean;
  setShowAdvanceHistoryModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const AdvanceHistoryModal: React.FC<AdvanceHistoryModalProps> = (props) => {
  const [advanceHistoryLoading, setAdvanceHistoryLoading] = useState(false);
  const [advanceHistory, setAdvanceHistory] =
    useState<IAdvanceHistoryReturnType>();
  const [advanceHistoryError, setAdvanceHistoryError] = useState<any>();

  useEffect(() => {
    getAdvanceRequestHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAdvanceRequestHistory = () => {
    setAdvanceHistoryLoading(true);
    axios
      .get(
        `${environment.baseUrl}/advancerequests/${props.advanceRequest.id}/payment_history/`
      )
      .then((res) => {
        setAdvanceHistory(res.data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setAdvanceHistory({
            total_hits: 0,
            hits: [],
          });
        } else {
          setAdvanceHistoryError(error.response);
          apiResponseHandler.handleApiError('Error', error);
        }
      })
      .finally(() => {
        setAdvanceHistoryLoading(false);
      });
  };

  return (
    <Modal className="modal-main" isOpen={props.showAdvanceHistoryModal}>
      <div className="history-modal-header-container">
        <ModalHeader className="history-modal-header">
          Transaction Details
        </ModalHeader>
        <button
          className="btn bg-transparent btn-outline-transparent"
          onClick={() => props.setShowAdvanceHistoryModal(false)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none">
            <path
              d="M18 6L6 18"
              stroke="#062133"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 6L18 18"
              stroke="#062133"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
      {(() => {
        let modalContent;
        if (advanceHistoryLoading) {
          modalContent = (
            <Col className="d-flex justify-content-center mt-3">
              <output className="spinner-border">
                <span className="sr-only">Loading...</span>
              </output>
            </Col>
          );
        } else if (advanceHistoryError) {
          modalContent = (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <text>Error status: {advanceHistoryError.status}</text>
              <text>Error message: {advanceHistoryError.data.message}</text>
            </div>
          );
        } else if (advanceHistory) {
          modalContent = (
            <>
              <EmployeeModalTable
                employee={props.advanceRequest.employee}
                advance={props.advanceRequest}
              />
              <br />
              <AdvanceProviderInformationTable
                advanceRequest={props.advanceRequest}
              />
              <br />
              <AdvanceStatusInfoTable advanceRequest={props.advanceRequest} />
              <br />
              <div>
                <ModalHeader className="history-table-header">
                  Transaction History
                </ModalHeader>
                <AdvanceHistoryModalTable advanceHistory={advanceHistory} />
              </div>
              {props.advanceRequest.payment_provider === 'paysoft' && (
                <PaysoftActionsSection
                  advanceId={props.advanceRequest.id}
                  sourceId={props.advanceRequest.source_id}
                />
              )}
            </>
          );
        } else {
          modalContent = null;
        }
        return modalContent;
      })()}
    </Modal>
  );
};

export default AdvanceHistoryModal;
